import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityMantesLaJoliePage() {
  const data = citiesData.find((c) => c.slug === "mantes-la-jolie")!;
  return <CityPage data={data} />;
}
